<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
        </section>

        <section class="dp-right">
            <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

            <div class="tbl-scroll-host">
            <el-table :data="items" v-loading="listLoading" @row-click="selectCurrentRow" ref="table" class="custom-tbl"
                height="100%" style="width: 100%">
                <el-table-column prop="StudentName" label="学生" width=""></el-table-column>
                <el-table-column prop="DepartmentName" label="部门" width=""></el-table-column>
                <el-table-column prop="LeaveType" label="请假类型" width="">
                    <template slot-scope="scope">{{ leaveTypeLabel(scope.row.LeaveType) }}</template>
                </el-table-column>
                <el-table-column prop="LeaveStart" label="请假开始" width="180">
                    <template slot-scope="scope">{{ formatDateTime(scope.row.LeaveStart) }}</template>
                </el-table-column>
                <el-table-column prop="LeaveEnd" label="请假结束" width="180">
                    <template slot-scope="scope">{{ formatDateTime(scope.row.LeaveEnd) }}</template>
                </el-table-column>
                <el-table-column prop="OutTime" label="出校时间" width="180">
                    <template slot-scope="scope">{{ formatDateTime(scope.row.OutTime) }}</template>
                </el-table-column>
                <el-table-column prop="ReturnTime" label="返校时间" width="180">
                    <template slot-scope="scope">{{ scope.row.ReturnTime ? formatDateTime(scope.row.ReturnTime) :
                        '-' }}</template>
                </el-table-column>
                <el-table-column prop="ExplanationStatus" label="说明状态" width="">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.ExplanationStatus ? 'success' : 'info'">{{
                            scope.row.ExplanationStatus ? '已提交' : '未提交' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="ExplanationContent" label="说明" min-width="">
                    <template slot-scope="scope">
                        <el-tooltip placement="top" effect="dark">
                            <div slot="content" style="white-space: pre-wrap; word-break: break-all; max-width: 400px;">
                                {{
                                    scope.row.ExplanationContent || '' }}</div>
                            <div
                                style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: inline-block; max-width: 100%;">
                                {{ scope.row.ExplanationContent || '-' }}</div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="ExplanationImages" label="图片" width="">
                    <template slot-scope="scope">
                        <div v-if="getImageList(scope.row).length > 0"
                            style="display:flex;flex-wrap:wrap;align-items:center">
                            <img v-for="(m, i) in getImageList(scope.row).slice(0, 3)" :key="i" v-oss-src="m"
                                style="width:60px; height:60px; object-fit:cover; margin-right:6px; margin-bottom:6px; cursor:pointer"
                                v-viewer />
                            <span v-if="getImageList(scope.row).length > 3" style="line-height:60px">...</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            </div>

            <!--工具条-->
            <el-col :span="24" class="toolbar">
                <el-pagination layout="total, prev, pager, next, jumper" :current-page="page" :page-size="pageSize"
                    :total="total" @current-change="handleCurrentChange" style="float: right"></el-pagination>
            </el-col>

        </section>
    </section>
</template>

<script>
import util from "../../../util/date";
import { getreturnoverduelist } from '../../api/modules/misc';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'

export default {
    components: { Toolbar, DepartmentPane },
    data() {
        return {
            searchList: [
                //{ label: '学生姓名', key: 'studentName', type: 'text' },
                { label: '日期', key: 'date', type: 'date' }
            ],
            buttonList: [],
            items: [],
            fullItems: [],
            listLoading: false,
            page: 1,
            pageSize: 10,
            total: 0,
            BaseApiUrl: BaseApiUrl,
            explainForm: { ExplanationId: 0, LeaveRefId: 0, Content: '', Images: [] },
            DepartmentId: 0
        };
    },
    methods: {
        formatDateTime(val) {
            if (!val) return '-';
            try {
                return util.formatDate.format(new Date(val), 'yyyy-MM-dd hh:mm:ss');
            } catch (e) {
                return val;
            }
        },
        leaveTypeLabel(type) {
            if (!type) return '-';
            if (type === 'LeaveRequest') return '普通请假';
            if (type === 'AgentDetail') return '代请假明细';
            return type;
        },
        getImageList(row) {
            try {
                const imgs = row && row.ExplanationImages ? row.ExplanationImages : [];
                return Array.isArray(imgs) ? imgs : [];
            } catch (e) {
                return [];
            }
        },
        treeNodeClick(data) {
            this.DepartmentId = data.value;
            this.handleQuery();
        },
        callFunction(item) {
            if (typeof item.search == 'object') {
                this.filters = item.search;
            } else {
                this.filters = { key: item.search };
            }
            if (item.Func && typeof this[item.Func] === 'function') {
                this[item.Func].apply(this, item);
            } else {
                this.handleQuery();
            }
        },
        handleCurrentChange(val) {
            this.page = val;
            if (this.fullItems && this.fullItems.length > 0) {
                this.applyClientPagination();
            } else {
                this.handleQuery();
            }
        },
        applyClientPagination() {
            try {
                const start = (this.page - 1) * this.pageSize;
                this.items = (this.fullItems || []).slice(start, start + this.pageSize);
                this.total = (this.fullItems || []).length;
            } catch (e) {
                this.items = [];
                this.total = 0;
            }
        },
        handleQuery() {
            // reset to first page when querying
            this.page = 1;
            const params = {
                page: this.page,
                pageSize: this.pageSize,
                departmentId: this.DepartmentId || 0,
                studentName: (this.filters && this.filters.studentName) || '',
                date: (this.filters && this.filters.date) || null
            };
            this.listLoading = true;
            getreturnoverduelist(params).then(res => {
                if (res && res.data && res.data.success) {
                    const resp = res.data.response || {};
                    let dataArray = [];
                    if (Array.isArray(resp.data)) {
                        dataArray = resp.data;
                        this.pageSize = resp.PageSize || this.pageSize;
                    } else if (Array.isArray(res.data.response)) {
                        dataArray = res.data.response;
                    }
                    // store full dataset and apply client-side paging
                    this.total = this.fullItems.length;
                    // clamp current page
                    const maxPage = Math.max(1, Math.ceil(this.total / this.pageSize));
                    if (this.page > maxPage) this.page = maxPage;
                    this.applyClientPagination();
                } else {
                    this.$message.error('获取返校超时列表失败');
                }
            }).catch(() => {
                this.$message.error('获取返校超时列表出错');
            }).finally(() => {
                this.listLoading = false;
            });
        },
        selectCurrentRow(row) {
            this.currentRow = row;
        },
    },
    mounted() {
        let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
        this.buttonList = getButtonList(this.$route.path, routers);
    }
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
    display: none
}
</style>
